import { HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
import { ApiResponse } from 'src/app/bo/apiResponse';
import { RequestProcessing } from 'src/app/bo/geoData/requestProcessing';
import { Orthophoto } from 'src/app/bo/orthophoto';
import { ProprieteAffichee } from 'src/app/bo/proprieteAffichee';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
// import { UploadGeotiffService } from 'src/app/services/upload-geotiff.service';

interface PreviewFile{
  fileUrlPreview: (string | ArrayBuffer);
  fileName:string;
  isChecked:boolean;
}

class FileInfo{
  fileName: string;
  fileSize:string;
  lastModified: string;
  isChecked:boolean;
}

@Component({
  selector: 'app-site-orthophotos-add-files-modal',
  templateUrl: './site-orthophotos-add-files-modal.component.html',
  styleUrls: ['./site-orthophotos-add-files-modal.component.scss'],
  standalone: false
})


export class SiteOrthophotosAddFilesModalComponent implements OnInit {

  @ViewChild('modalConfirmCancel') modalConfirmCancel: ModalDirective;
  @ViewChild('modalConfirmSuppr') modalConfirmSuppr: ModalDirective;
  TH_Width:number[] = [38,32,23];
  barWidth = 0;
  barValue = signal('0%');


  window:number;
  multi: boolean;
  types:string[];
  files: File[] = [];
  filesInfo:FileInfo[] = [];
  formData:FormData = undefined;
  reader = new FileReader();
  previewFiles: PreviewFile[] = []
  proprietesAffichees:ProprieteAffichee[] = [];
  isIconShow = true;
  showErrorMsg = signal(false);
  msgErrorContent = signal('');
  orthophotos: Orthophoto[] = [];
  errorMessage = signal('');

  constructor(
    public bsModalRef: BsModalRef,
    private readonly http: HttpService,
    public fonctionsService: FonctionsService,
    public utilService: UtilisateurService,
    private readonly translate: TranslateService,
    private readonly bsModalService: BsModalService
    // private el: ElementRef,
    // private geotiffService: UploadGeotiffService,
    ) { }


  ngOnInit(): void {
    this.proprietesAffichees = new RequestProcessing().getProprietesAfficheesUploadImage();
  }

  public dropped(f: NgxFileDropEntry[]) {
    this.fonctionsService.loading_screen(true);

    this.previewFiles = [];
    this.files = [];
    this.filesInfo = [];
     for (const droppedFile of f) {
      const fileInfo: FileInfo = new FileInfo();
      // Is it a file?
      if (droppedFile.fileEntry.isFile && this.isFileAllowed(droppedFile.fileEntry.name)) {
        this.isIconShow = false;
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        
        fileEntry.file( (file: File) => {
          this.files.push(file)
          fileInfo.fileName =  file.name;
          fileInfo.fileSize = (file.size / (1024 ** 2)).toFixed(2).toString() + 'Mb';
          fileInfo.lastModified = new Date(file.lastModified).toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          });
          fileInfo.isChecked = false;
        });
        this.filesInfo.push(fileInfo);
      } else {
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        this.isIconShow = true;
      }
    }

    setTimeout(() => {
      this.managerFile(); 
    }, 10 * f.length);

    if(this.window != 2){
      this.fonctionsService.loading_screen(false);
      return;
    } 

    setTimeout(() => {
      if(this.files.length > 0){
        this.createImageFromBlob() ;
        this.fonctionsService.loading_screen(false);
      }else{
        this.fonctionsService.loading_screen(false);
      }
    }, 10 * f.length);
  }

  protected selectImage(index:  number){
    if(this.window == 2)
       this.previewFiles[index].isChecked = !this.previewFiles[index].isChecked;

    this.filesInfo[index].isChecked = !this.filesInfo[index].isChecked;
  }

  protected deleteSelectedFilesFromList(){
   if(this.window == 2)
      this.previewFiles = this.previewFiles.filter((x,i) => x.isChecked == false);

   this.filesInfo = this.filesInfo.filter((x) => x.isChecked == false);
   this.files = this.files.filter((x) => this.filesInfo.find(({fileName}) => x.name == fileName));
   
   this.managerFile(); 

   if(this.filesInfo.length == 0) this.isIconShow = true;
  }

  protected hideModal(value = ''){
    this.bsModalService.setDismissReason(value);
    this.bsModalRef.hide();
  }

  // protected checkStrayosUpload(){
  //   if(this.filesInfo.length < 10 || this.filesInfo === undefined || this.filesInfo === null){
  //    this.showErrorMsg = true;
  //    this.msgErrorContent = '10 photos min.';
  //    setTimeout(() => {
  //     this.showErrorMsg = false;
  //     this.msgErrorContent = '';
  //   }, 1500);
  //   }else{
  //     this.uploadStrayosFiles();
  //   }
  // }

  protected uploadOrthoFiles(){
    if(this.filesInfo.length !==1 || this.filesInfo === null){
      this.showErrorMsg.set(true);
      this.msgErrorContent.set('1 photos min.');
       setTimeout(() => {
        this.showErrorMsg.set(false);
        this.msgErrorContent.set('');
      }, 1500);
    }else{
       if(this.orthophotos.some(el => el.name === this.filesInfo[0].fileName.split('.')[0])){
        this.showErrorMsg.set(true);
        this.msgErrorContent.set('name already exists');
        setTimeout(() => {
          this.showErrorMsg.set(false);
          this.msgErrorContent.set('');
        }, 1500);
        return;
       }
      const url = "sites/" + this.utilService.currentSite().siteId + "/map/Upload" ;
      this.uploadFiles(url);
     }
  }

  private createImageFromBlob() {
    this.previewFiles = [];
    for (let i = 0; i < this.files.length; i++) {
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        const result = reader.result;
        const previewFile: PreviewFile = {
          fileUrlPreview: result,
          fileName: this.files[i].name,
          isChecked:false
        }
        this.previewFiles.push(previewFile);
      }, false);
      if (this.files[i]) {
        reader.readAsDataURL(this.files[i] as Blob);
      }
    }
  }

  ///create formData for upload files
  private managerFile() {
    this.formData = new FormData();
    for (let i = 0; i < this.files.length; i++) {
      this.formData.append('files', this.files[i], this.files[i].name.toLocaleLowerCase());
    }
  }



  private isFileAllowed(fName: string) {
    const fileName = fName.toLowerCase();
    let isFileAllowed = false;
    const allowedJPG = ['.jpg', '.jpeg'];
    const allowedTIF = ['.tif'];
    const allowedFiles = this.window === 1 ? allowedTIF : allowedJPG;
    const regex = /(?:\.([^.]+))?$/;
    const extension = regex.exec(fileName);
    // const extension = fileName.split('.').pop();
    if (undefined !== extension && null !== extension) {
      for (const ext of allowedFiles) {
        if (ext === extension[0]) {
          isFileAllowed = true;
          break;
        }else{
          this.translate.get('GEODATA.UNAUTHORIZED_FORMAT').subscribe(trad => {
            this.fonctionsService.launch_toast(false, false, trad);
          });
        }
      }
    }
    return isFileAllowed;
  }

  private uploadFiles(url:string){
    this.fonctionsService.loading_screen(true);
    this.http.postFiles(url, this.formData)
    .pipe(map(event=> {
       if(event.type == HttpEventType.UploadProgress){
          this.barValue.set(Math.round((100 / (event.total || 0) * event.loaded)) + '%');
       }else if(event.type == HttpEventType.Response){
           let apiResponse: ApiResponse<any> = event.body as ApiResponse<any>;

           if(apiResponse.statusCode === 500){
                 this.fonctionsService.launch_toast(false, false, apiResponse.message);
           }else{
            setTimeout(() => {
              this.barValue.set('0%');
            }, 500);
            this.fonctionsService.loading_screen(false);
            this.fonctionsService.launch_toast(true);
            this.bsModalRef.hide();
           }
       }
      }
    )).subscribe({
      next:() =>{
      },
      error: (error) =>{
        const backendMessage = error?.error || error?.message || '';
        this.processErrorMessage(backendMessage);
        this.fonctionsService.launch_toast(false) ;
        this.fonctionsService.loading_screen(false);
      }
   
    } )
  }

  private processErrorMessage(backendMessage: string): void {
    if (typeof backendMessage === 'string' && backendMessage.startsWith('APIERROR.')) {
      this.translate.get(backendMessage).subscribe({
        next: (translatedMessage) => {
          if (translatedMessage && translatedMessage !== backendMessage) {
            this.errorMessage.set(translatedMessage);
          } else {
            this.errorMessage.set('');
          }
        },
        error: () => {
          this.errorMessage.set('');
        }
      });
    } else {
      this.errorMessage.set('');
    }
  }

  closeErrorMessage(): void {
    this.errorMessage.set('');
  }

}
